import { useEffect } from 'react';
import { publishUsableWorkingProject, useWorkingProject } from '@/api/iam';

/** Keeps the snapshot that the request interceptor reads (`readUsableWorkingProject`) equal to what the top bar shows. */
export function WorkingProjectSync() {
  const { project, settled } = useWorkingProject();
  useEffect(() => {
    publishUsableWorkingProject({ project, settled });
    return () => publishUsableWorkingProject({ project: null, settled: false });
  }, [project, settled]);
  return null;
}
